import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus() {
  return Complex.createComplex(0, 0);
}

export function computeComplexFF() {
  return Complex.createComplex(0, 0);
}
